import { RotateCw } from "react-feather";
function Loading() {
    return (
        <>
            <div className="loadingDiv">
                <span>
                    <RotateCw className="loadingIcon"></RotateCw>
                </span>{" "}
                &nbsp; loading
            </div>
        </>
    );
}
export default Loading;
